import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getTypeproducts = async ({ commit }) => {
  commit('setTypeproductIsLoading', true);
  let url = `/typeproducts/selectable`;

  await connection.get(url)
    .then(res => {
      const typeproducts = res.data.data;
      commit('setTypeproductsSelectable', typeproducts);
      commit('setTypeproductIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setTypeproductIsLoading', false);
    });
}

export const loadTypeproducts = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setTypeproductIsLoading', true);
    let url = `/typeproducts`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const typeproducts = res.data.data;
        commit('setTypeproducts', typeproducts);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setTypeproductsPaginated', res.data);
        commit('setTypeproductIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setTypeproductIsLoading', false);
      });
}

export const typeproductById = async ({ commit }, id) => {
  commit('setTypeproductIsLoading', true);
  await connection.get(`/typeproducts/${id}`)
    .then(res => {
      commit('setTypeproductDetail', res.data.data);
      commit('setTypeproductIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setTypeproductIsLoading', false);
    });
}

export const storeTypeproduct = async ({ commit }, typeproduct) => {
  commit('setTypeproductIsCreating', true);
  await connection.post(`/typeproducts/create`, typeproduct)
    .then(res => {
      commit('saveNewTypeproducts', res.data.data);
      commit('setTypeproductIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setTypeproductIsCreating', false);
    });
}

export const updateTypeproduct = async ({ commit }, typeproduct ) => {
  commit('setTypeproductIsUpdating', true);
  await connection.put(`/typeproducts/${typeproduct.id}/update`, typeproduct)
    .then(res => {
      commit('saveUpdatedTypeproduct', res.data.data);
      commit('setTypeproductIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setTypeproductIsUpdating', false);
    });
}

export const deleteTypeproduct = async ({ commit }, typeproduct) => {
  commit('setTypeproductIsDeleting', true);
  await connection.delete(`/typeproducts/${typeproduct.id}/delete`)
    .then(res => {
      console.log(res);
      commit('setDeleteTypeproduct', res.data.data);
      commit('setTypeproductIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setTypeproductIsDeleting', false);
    });
}
